import { Button, Typography } from "antd";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import DeleteConfirmation from "../../../components/delete.confirmation";

const { Text } = Typography;

export const caseTableColumns = ({
  handleViewCase,
  handleDeleteCase,
  notificationApi,
}) => [
  {
    title: "Created",
    dataIndex: "createdAt",
    render: (date) => new Date(date).toLocaleDateString(),
    sorter: (a, b) => a.createdDate - b.createdDate,
    defaultSortOrder: "descend",
  },
  {
    title: "Theme",
    dataIndex: ["theme"],
    showSorterTooltip: { target: "full-header" },
    render: (text, record) => <Text>{record?.theme?.name}</Text>,
    onFilter: (value, record) => record?.formName.indexOf(value) === 0,
    sorter: (a, b) => a.theme?.name.length - b.theme?.name.length,
  },
  {
    title: "Case",
    dataIndex: ["title"],
    showSorterTooltip: { target: "full-header" },
    render: (text, record) => <Text>{text}</Text>,
    onFilter: (value, record) => record.formName.indexOf(value) === 0,
    sorter: (a, b) => a?.length - b?.length,
  },
  {
    title: "Scenario",
    dataIndex: "scenario",
    render: (text, record) => (
      <div dangerouslySetInnerHTML={{ __html: text }}></div>
    ),
  },
  {
    title: "Actions",
    dataIndex: "None",
    render: (_, record) => (
      <div style={{ display: "flex", gap: 8 }}>
        <Button
          type="text"
          onClick={() => handleViewCase(record)}
          icon={<EyeOutlined />}
        />

        <Button
          type="text"
          onClick={() => handleViewCase(record)}
          icon={<EditOutlined />}
        />

        <DeleteConfirmation
          resource={record}
          notifyApi={notificationApi}
          deleteResource={() => handleDeleteCase(record)}
          onDeleteSuccess={() => null}
        />
      </div>
    ),
  },
];

export const conditionsTableColumns = ({
  notificationApi,
  handleViewCondition = (data) => null,
  handleDeleteCondition = (data) => null,
}) => [
  {
    title: "Created",
    dataIndex: "createdDate",
    render: (date) => new Date(date).toLocaleDateString(),
    sorter: (a, b) => a.createdDate - b.createdDate,
    defaultSortOrder: "descend",
  },
  {
    title: "Condition",
    dataIndex: ["formName"],
    showSorterTooltip: { target: "full-header" },
    render: (text, record) => <Text>{text}</Text>,
    onFilter: (value, record) => record.formName.indexOf(value) === 0,
    sorter: (a, b) => a?.formName?.length - b?.formName?.length,
  },
  {
    title: "Clinical description",
    dataIndex: "description",
    render: (text, record) => (
      <Typography.Paragraph
        ellipsis={{
          rows: 3,
          expandable: true,
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: text ?? "" }}></div>
      </Typography.Paragraph>
    ),
  },
  {
    title: "Actions",
    dataIndex: "None",
    render: (_, record) => (
      <div style={{ display: "flex", gap: 8 }}>
        <Button
          type="text"
          onClick={() => handleViewCondition(record)}
          icon={<EyeOutlined />}
        />

        <Button
          type="text"
          onClick={() => handleViewCondition(record)}
          icon={<EditOutlined />}
        />

        <DeleteConfirmation
          resource={record}
          notifyApi={notificationApi}
          deleteResource={() => handleDeleteCondition(record)}
          onDeleteSuccess={() => null}
        />
      </div>
    ),
  },
];

export const coursesTableColumns = ({
  notificationApi,
  handleView = (data) => null,
  handleDelete = (data) => null,
}) => [
  {
    title: "Created",
    dataIndex: "createdAt",
    render: (date) => new Date(date).toLocaleDateString(),
    sorter: (a, b) => a.createdAt - b.createdAt,
    defaultSortOrder: "descend",
  },
  {
    title: "Course",
    dataIndex: ["title"],
    showSorterTooltip: { target: "full-header" },
    render: (text, record) => <Text>{text}</Text>,
    onFilter: (value, record) => record.title.indexOf(value) === 0,
    sorter: (a, b) => a?.title?.length - b?.title?.length,
  },
  {
    title: "Description",
    dataIndex: "description",
    render: (text, record) => (
      <Typography.Paragraph
        ellipsis={{
          rows: 3,
          expandable: true,
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: text ?? "" }}></div>
      </Typography.Paragraph>
    ),
  },
  {
    title: "Actions",
    dataIndex: "None",
    render: (_, record) => (
      <div style={{ display: "flex", gap: 8 }}>
        <Button
          type="text"
          onClick={() => handleView(record)}
          icon={<EyeOutlined />}
        />

        <Button
          type="text"
          onClick={() => handleView(record)}
          icon={<EditOutlined />}
        />

        <DeleteConfirmation
          resource={record}
          notifyApi={notificationApi}
          deleteResource={() => handleDelete(record)}
          onDeleteSuccess={() => null}
        />
      </div>
    ),
  },
];